const errorMessages = {
  robotOffline: 'Your robot appears to be offline. It may take up to 1 minute to be detectable after being switched on. For assistance, please contact support',
  missionNotFound: 'Your mission ID was not found.',
  profileUpdateSuccess: 'Your profile has been updated successfully!',
  profileNotSelected: 'Your profile has not been selected.',
  kycCompleted: 'Your KYC has been successfully completed.',
  deviceIdNotFound: 'The device ID and mission ID were not found.',
  somethingWentWrong: 'Something went wrong. Please contact support if you continue to experience this issue.',
  lastRideTerminated: 'Your last ride has been terminated. Please start from the home point again otherwise, you will not be able to reach other checkpoints.',
  botOffline: 'Bot is offline',
  usernameTaken: 'Username has already been taken',
  driveToStartingPoint: 'Please drive the bot to the starting point.',
  rideTerminated: 'Your ride has been terminated.',
  feedbackSubmittedSuccess: 'Your feedback has been successfully submitted.',
  addFeedback: 'Please add your feedback..',
  noTestReadyBot: 'No test_ready bot has been found.',
  terminateRideFailed: 'Sorry! We were unable to terminate your ride, please try again.',
  botDetailsNotAvailable: 'Bot details not available.',
  paymentSuccess: 'Payment successful!',
  paymentProcessing: 'Your payment is processing.',
  paymentFailed: 'Your payment was not successful, please try again.',
  makePublic: 'Your Earth Rover is public.',
  makePrivate: 'Your Earth Rover is private.',
};

export default errorMessages;  